<template>
  <!-- 安祥法宝 -->
  <div class="plowCloudBrief">
    <topBack>{{ $t("navName")[2] }}</topBack>
    <!-- 导航 -->
    <barF5></barF5>
    <header class="plowCloudNav flex-between-wrap">
      <div
        v-for="(item, index) in childNav"
        :key="index"
        class="navItem"
        :class="{ activeNav: index == nowIndex }"
        @click="changeNav($event, index)"
      >
        {{ item.cate_name }}
      </div>
    </header>
    <barF5></barF5>
    <!-- 内容 -->
    <div class="container">
      <word
        v-if="nowIndex == 0"
        :content="wordList"
        :title="childNav[0].cate_name"
      ></word>
      <puzzle-book
        v-if="nowIndex == 1"
        :content="puzzleList"
        :title="childNav[1].cate_name"
      ></puzzle-book>
      <opus
        v-if="nowIndex == 2"
        :content="opusList"
        :title="childNav[2].cate_name"
      ></opus>
      <!-- <poetry v-if="nowIndex == 3" :content="poetryList" :title="childNav[3].cate_name"></poetry> -->
      <poetry v-if="nowIndex == 3" :title="childNav[3].cate_name"></poetry>

      <videos v-if="nowIndex == 4"></videos>
      <frenchp
        v-if="nowIndex == 5"
        :content="frenchpList"
        :title="childNav[5].cate_name"
      ></frenchp>

      <zen-music v-if="nowIndex == 6"></zen-music>
      <ancient-books
        v-if="nowIndex == 7"
        :content="ancientBooksList"
        :title="childNav[7].cate_name"
      ></ancient-books>
    </div>
    <!-- 去除底部button所占的位置 -->
    <!-- <empty></empty> -->
    <!-- 底部button -->
    <!-- <footer>
            <Button>{{$t('firstHome')}}</Button>
        </footer> -->
  </div>
</template>

<script>
import {
  getCateList,
  getSpeechList,
  getDispelDoubtsList,
  getBookList,
  // getPoetry,
  getSoundCate,
  getAncientBooksList,
} from "../../api/apis";
import { getNavName } from "../../common/js/common.js";
import topBack from "../../components/topBack.vue";
import barF5 from "../../components/barF5"; //空隙bar
import word from "./word"; //耕雲導師講詞
import puzzleBook from "./puzzleBook"; //耕雲導師解惑录
import opus from "./opus"; //耕雲導師書籍及著作

import poetry from "./poetry"; //耕雲導師詩歌及語法
import videos from "./videos"; //耕雲導師說法視頻
import frenchp from "./frenchp"; //耕雲導師法音
import zenMusic from "./zenMusic"; //安祥禪曲
import ancientBooks from "./ancientBooks"; //學禪典籍

import empty from "../../components/empty";
import Button from "../../components/button";
export default {
  name: "magicWeapon",
  components: {
    topBack,
    barF5,
    word,
    puzzleBook,
    opus,
    poetry,
    videos,
    frenchp,
    zenMusic,
    ancientBooks,
    empty,
    Button,
  },
  props: {},
  data() {
    return {
      nowIndex: 0,
      cateId: 0,
      //  cateId: 8,
      childNav: [],
      wordList: [], //讲词
      puzzleList: [], //解惑录
      opusList: [], //著作
      // poetryList: [], //诗歌和法语

      frenchpList: [], //法音列表

      ancientBooksList: [], //学禅典籍列表
    };
  },
  methods: {
    changeNav(e, index) {
      this.$router.push({
        path: "/magicWeapon",
        query: {
          id: index,
        },
      });
      this.nowIndex = index;
    },
  },
  created() {
    this.nowIndex = this.$route.query.id ? this.$route.query.id : 0
    getCateList().then((res) => {
      let nowIndex = this.nowIndex;

      // this.childNav = res[1];
      this.childNav = getNavName(res[1]);
      console.log(this.childNav);
      this.cateId = res[1][nowIndex].id;

      //耕耘导师讲词
      getSpeechList(res[1][nowIndex].id).then((res) => {
        this.wordList = res;
      });
      //耕云导师解惑录
      getDispelDoubtsList(res[1][1].id).then((res) => {
        this.puzzleList = res;
      });
      // 著作
      getBookList(res[1][2].id).then((res) => {
        this.opusList = res;
        // this.opusList = [
        //     {
        //         id: 18,
        //         news_title: "爱的人生"
        //     },
        //     {
        //         id: 17,
        //         news_title: "观潮随笔"
        //     }
        // ];
      });
      // //诗歌和法语
      // getPoetry(res[1][3].id).then(res => {
      //     this.poetryList = res;
      // });
      //法音列表
      getSoundCate(res[1][5].id).then((res) => {
        this.frenchpList = res;
      });
      //安祥禅法宝-学禅典籍列表
      getAncientBooksList(res[1][7].id).then((res) => {
        this.ancientBooksList = res;
      });
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.plowCloudNav {
  /* display: grid;
    grid-template-columns: repeat(2, 49.5%);
    grid-column-gap: 0.15rem;
    grid-row-gap: 0.15rem; */
  padding: 0.64rem;
  text-align: left;
}

.navItem {
  width: 9.23rem;
  height: 1.71rem;
  margin: 0.15rem 0;
  box-sizing: border-box;
  line-height: 1.71rem;
  background-color: #f4f3ee;
  color: #666666;
  padding-left: 1.07rem;
  font-size: 0.85rem;
  font-weight: 600;
}

.activeNav {
  background-color: #047bcd;
  color: #fff;
}

.container {
  /* padding: 0.64rem; */
  color: #333333;
  text-align: left;
}
</style>